<template>
    <div v-if="services && services.length">
        <div class="mb-4">
            <div class="bg-red-100 border-l-4 border-red-500 text-red-700 px-4 py-3 sau-font sm" role="alert">
                <p>
                    <span>The following services have been suspended due to unpaid invoices.</span>
                    <span>Reactivate services by paying all outstanding invoices.</span>
                </p>
                <div class="text-xs">* For immediate reactivation of suspended services, use an instant payment method (Credit Card or PayPal).</div>
            </div>
        </div>
        <div class="sau-bx">
            <div class="sau-dynamic-preview-bx">
                <table class="sau-bx-table">
                    <tbody>
                        <template v-for="service in services">
                            <tr v-for="(invoice, i) in service.invoices" :key="`${service.order_id}.${invoice.invoice_no}`">
                                <!-- Service Details -->
                                <th v-if="i === 0" :rowspan="service.invoices.length" style="vertical-align: top">
                                    <div class="mt-2 flex flex-row gap-2">
                                        <div class="w-auto"><i class="fal fa-server"></i></div>
                                        <div class="w-auto">
                                            <div>{{service.order_id}}</div>
                                            <div class="sau-font sm" v-if="service.matchedProduct">{{service.matchedProduct.name}}</div>
                                        </div>
                                    </div>
                                </th>
                                <!-- Invoices -->
                                <td width="40"><span title="Overdue" class="xs sau-dot overdue"></span></td>
                                <td width="40"><i class="fal fa-file-invoice"></i></td>
                                <td>
                                    <a :href="`/billing/invoices/${invoice.invoice_no}`" class="sau-linx-hover gray">
                                    Invoice No: {{invoice.invoice_no}}
                                    </a>
                                </td>
                                <td align="right">{{ invoice.total | currency }}</td>
                                <td class="text-danger sau-font xs" align="right">{{ invoice.status_text }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    computed:{
        ...mapState([
            'overdueServices',
            'productCategories'
        ]),
        services() {
            return this.overdueServices.map(service => {
                return {
                    ...service,
                    matchedProduct: this.getMatchedProduct(service.product),
                }
            });
        }
    },
}
</script>

<style>
.sau-dot.overdue {
    background-color: #d8534f;
}
</style>

